export const frontmatter = {
    "draft": false,
    "title": "Guía: Configuración del tenant",
    "description": "Cómo acceder y configurar un Tenant Default o Tenant Enterprise en OnnIA: datos de identificación, usuarios, canales y políticas de retención.",
    "sidebar_label": "Configuración del tenant",
    "sidebar_group": "referencia",
    "sidebar_order": 3
}

export const toc = [
    {
        "depth": 2,
        "id": "tipos-de-tenant",
        "value": "Tipos de tenant"
    },
    {
        "depth": 2,
        "id": "acceso-a-un-tenant",
        "value": "Acceso a un tenant"
    },
    {
        "depth": 2,
        "id": "configuracion-general",
        "value": "Configuración general"
    },
    {
        "depth": 3,
        "id": "datos-de-identificacion",
        "value": "Datos de identificación"
    },
    {
        "depth": 3,
        "id": "informacion-de-contacto",
        "value": "Información de contacto"
    },
    {
        "depth": 3,
        "id": "direccion-y-ubicacion",
        "value": "Dirección y ubicación"
    },
    {
        "depth": 3,
        "id": "identidad-visual-e-idioma",
        "value": "Identidad visual e idioma"
    },
    {
        "depth": 2,
        "id": "gestion-de-usuarios",
        "value": "Gestión de usuarios"
    },
    {
        "depth": 2,
        "id": "politicas-de-retencion-de-datos",
        "value": "Políticas de retención de datos"
    },
    {
        "depth": 2,
        "id": "tenant-enterprise-capacidades-adicionales",
        "value": "Tenant Enterprise: capacidades adicionales"
    }
]